export class PageNotFound404Error extends Error {}
export class PermissionDenied403Error extends Error {
  constructor(message, options) {
    super(message);
    this.tenantsToRedirect = options?.tenantsToRedirect;
    this.documentPk = options?.documentPk;
  }
}
